import { useCallback } from 'react'
import { TLoadTypesSchema } from 'transfix-form/forms/CarrierLoadPreferences/components/LoadTypesModal/schema/LoadTypesSchema'
import { IUseCarrierLoadPreferencesSubmitter } from 'transfix-form/forms/CarrierLoadPreferences/types'
import { useGlobalToast } from 'transfix-ui/components/Toast/GlobalToast'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks/useFMSAnalytics/useFMSAnalytics'
import { TOAST_ERROR_MESSAGE } from '../../../constants'
import { useUpdateLoadTypesPreferencesMutation } from '../graphql/UpdateLoadTypesPreferencesMutation'

const TOAST_SUCCESS_MESSAGE = 'Load types updated successfully'

export const useLoadTypesSubmitter = (
  motorCarrierId: string
): IUseCarrierLoadPreferencesSubmitter<TLoadTypesSchema> => {
  const { openToast } = useGlobalToast()
  const { trackEvent } = useFMSAnalytics()
  const [updateLoadTypes, { loading }] = useUpdateLoadTypesPreferencesMutation()

  const showErrorToast = useCallback(() => {
    openToast({ toastMessage: TOAST_ERROR_MESSAGE, toastType: 'alert' })
  }, [openToast])

  const submitHandler = useCallback(
    async (formValues: TLoadTypesSchema) => {
      try {
        const { errors } = await updateLoadTypes({
          variables: {
            input: {
              motorCarrierId,
              ...formValues,
            },
          },
        })
        if (!errors) {
          trackEvent('Carrier Profile', 'UPDATED_CARRIER_PREFERENCE', {
            type: 'load_types',
          })
          trackEvent('Carrier Profile', 'UPDATED_LOAD_TYPES')
          openToast({ toastMessage: TOAST_SUCCESS_MESSAGE })
          return true
        }
        showErrorToast()
        return false
      } catch (e) {
        showErrorToast()
        return false
      }
    },
    [motorCarrierId, openToast, showErrorToast, trackEvent, updateLoadTypes]
  )

  return {
    loading,
    submitHandler,
  }
}
